// extracted by mini-css-extract-plugin
export default {"highlightText":"HighlightText_highlightText__vtYTd","highlight":"HighlightText_highlight__d69tV"};